/**
 * Sentry — Error tracking & performance monitoring
 *
 * Inicializado no main.tsx. Só ativa se VITE_SENTRY_DSN estiver configurado.
 * Em dev (localhost) roda em modo debug mas NÃO envia events.
 */
import * as Sentry from '@sentry/react';
import { buildInfo } from '@/lib/version';

const DSN = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!DSN) {
    console.info('[Sentry] DSN não configurado — monitoramento desativado');
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE, // 'development' | 'production'
    release: `condoclick@${buildInfo.version}`,

    // Performance: captura 20% das transações em prod, 100% em dev
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,

    // Replay: captura 10% das sessões, 100% das que tiveram erro
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],

    // Não enviar erros de extensões do browser (MetaMask, etc.)
    beforeSend(event) {
      const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
      const isExtension = frames.some(f =>
        f.filename?.includes('content.js') ||
        f.filename?.includes('chrome-extension') ||
        f.filename?.includes('moz-extension')
      );
      if (isExtension) return null;
      return event;
    },
  });
}

export { Sentry };
